import { FixedDimension, PercentDimension, HtmlGraphicObject, GraphicCanvas } from "../../../../../web-graphics";
import { GraphicObjectCreator } from "./graphic-object-creator";

export class PlotCreator extends GraphicObjectCreator {
  constructor(commonSettings) {
    super();
    this.commonSettings = commonSettings;
  }

  static prepareSettings(settings, commonSettings) {
    const htmlGraphicParent = HtmlGraphicObject.findHtmlGraphicObject(settings._parentObject);
    settings.location = {
      x: settings.x?.copy() ?? new FixedDimension(0),
      y: settings.y?.copy() ?? new FixedDimension(0)
    };
    settings.size = {
      width: settings.width?.copy() ?? new PercentDimension(1),
      height: settings.height?.copy() ?? new PercentDimension(1)
    };
    settings.parent = {
      ref: settings._parentObject
    };
    
    if (htmlGraphicParent instanceof GraphicCanvas) {
      const htmlParentElement = htmlGraphicParent.settings.htmlObject.ref.parentElement;
      settings.htmlObject = {
        parent: {
          ref: htmlParentElement
        },
        graphicParent: htmlGraphicParent
      };
    } else {
      settings.htmlObject = {
        parent: {
          ref: htmlGraphicParent.settings.htmlObject.ref
        },
        graphicParent: htmlGraphicParent
      };
    }
    settings.common = commonSettings;
  }

  createPlotObject(/*settings*/) {
    return undefined;
  }

  create(settings) {
    let calllbackArray = this.callbacks.get("beforeCreate");
    calllbackArray.forEach(callback => callback(settings, this));
    PlotCreator.prepareSettings(settings, this.commonSettings);
    const plotObject = this.createPlotObject(settings);
    calllbackArray = this.callbacks.get("afterCreate");
    calllbackArray.forEach(callback => callback(plotObject, settings, this));
    return plotObject;
  }
}
